module.exports = __webpack_public_path__ + "static/danut-4efa665c972837a34907fb7e14c06014.jpg";